exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".viz-title,\n.viz-subtitle {\n  max-width: 40rem;\n  margin: 0 auto;\n}\n\n.viz-title {\n  font-weight: bold;\n  margin-bottom: 0.25rem;\n}\n.viz-subtitle {\n  font-size: 1rem;\n  font-style: italic;\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .viz-title, .viz-subtitle {\n    margin-left: 0.5rem;\n  }\n}", ""]);

